export const version = "rlp/5.0.2";
//# sourceMappingURL=_version.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ethersproject/rlp/lib.esm/_version.js
// module id = 2069
// module chunks = 4